export default {
  namespaced: true,
  state: () => ({
    defaultExpandedKeys: [],
    defaultCheckedKeys: [],
    lastSelectIds: new Map()
  }),
  getters: {
    lastSelectIds: state => state.lastSelectIds,
    defaultExpandedKeys: state => state.defaultExpandedKeys,
    defaultCheckedKeys: state => state.defaultCheckedKeys
  },
  mutations: {
    lastSelectIds (state, data) {
      state.lastSelectIds.set(data.id, data.data)
    },
    defaultExpandedKeys (state, defaultExpandedKeys) {
      state.defaultExpandedKeys = defaultExpandedKeys
    },
    defaultCheckedKeys (state, defaultCheckedKeys) {
      state.defaultCheckedKeys = defaultCheckedKeys
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/AuditSelectSite.js